import {FormComponentProps} from 'antd/es/form'
import React, {useEffect, useState} from 'react'
import {Form, message, Spin} from 'antd'
import {updateConfirmUser} from '../../authorization-module/login/service'
import {useParams} from 'react-router-dom'

interface Param {
    current: number
    setCurrent: Function
    freeUser: any
    setFreeUser: Function
    setEmail: Function
}

type Props = Param & FormComponentProps
const LandingPageSelfPortal: React.FC<Props> = (props: Props) => {

    return (
        <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%'
        }}>
            <Spin tip="Waiting for redirect..." size="large"></Spin>
        </div>
    )
}

const LandingPageSelf = Form.create<Props>({ name: 'Step3Free' })(LandingPageSelfPortal)
export default LandingPageSelf
